import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    return /*#__PURE__*/ _jsx(Svg, _object_spread_props(_object_spread({
        width: 20,
        height: 20,
        viewBox: "0 0 20 20"
    }, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M10 13.0625L5 8.0625L6.0625 7L10 10.9375L13.9375 7L15 8.0625L10 13.0625Z",
            fill: "#9FA9B9"
        })
    }));
};
export default Icon;
